/// <amd-module name="typeahead/core/userfeedbacktool/ui/UserFeedbackBox" />
/// <amd-dependency path="typeahead/core/loc" name="loc"/>

import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

const feedbackHtml: string = `
    <div class="feedbackBox" id="feedbackBox">
        <label id="explain_issue_id" class="explain-issue-message">
            If you have a moment, please let us know what issue you were experiencing:
        </label>
        <ul id="explain_issue_radiogroup" class="radiogroup no-outline" role="radiogroup"
            aria-labelledby="explain_issue_id">
            <li>
                <input type="radio" name="issue" class="user_feedback" id="rd1" value="missing_information"
                role="radio" aria-labelledby="missing-message">
                <label for="rd1" id="missing-message">Missing Information</label></li></input>
            <li>
                <input type="radio" name="issue" class="user_feedback" id="rd2" value="wrong_information" role="radio"
                    aria-labelledby="wrong-message">
                <label for="rd2" id="wrong-message">Wrong Information</label></input>
            </li>
            <li>
                <input type="radio" name="issue" class="user_feedback" id="rd3" value="irrelevant_information"
                role="radio" aria-labelledby="irrelevant-message">
                <label for="rd3" id="irrelevant-message">Irrelevant Information</label></input>
            </li>
            <li>
                <input type="radio" name="issue" class="user_feedback" id="rd4" value="other" role="radio"
                     aria-labelledby="other-message">
                <label for="rd4" id="other-message">Other</label></input>
            </li>
        </ul>
        <textarea class="field otherField" placeholder="Please describe your issue."></textarea>
        <label id="destination_type_label" class="box-title what-destination-type-message"></label>
        <ul class="checkbox" role="group" aria-labelledby="destination_type_label">
            <li>
                <input role="checkbox" type="checkbox" name="destination" class="user_feedback" id="cb1" value="city"
                    aria-labelledby="city">
                <label for="cb1" id="city">City</label>
            </li>
            <li>
                <input role="checkbox" type="checkbox" name="destination" class="user_feedback" id="cb2"
                    aria-labelledby="address" value="address">
                <label for="cb2" id="address">Address</label>
            </li>
            <li>
                <input role="checkbox" type="checkbox" name="destination" class="user_feedback" id="cb3"
                    value="landmark" aria-labelledby="landmark">
                <label for="cb3" id="landmark">Landmark</label>
            </li>
            <li>
                <input role="checkbox" type="checkbox" name="destination" class="user_feedback" id="cb4" value="hotel"
                    aria-labelledby="hotel">
                <label for="cb4" id="hotel">Hotel</label>
            </li>
            <li>
                <input role="checkbox" type="checkbox" name="destination" class="user_feedback" id="cb5"
                    value="train_station" aria-labelledby="train_station">
                <label for="cb5" id="train_station">Train Station</label>
            </li>
            <li>
                <input role="checkbox" type="checkbox" name="destination" class="user_feedback" id="cb6"
                    value="airport" aria-labelledby="airport">
                <label for="cb6" id="airport">Airport</label>
            </li>
        </ul>
        <span id="add_comment_label" class="add-comment" style="font-size: 12px;">
            Add a comment (optional)
        </span>
        <textarea class="field comment" aria-labelledby="add_comment_label"></textarea>
    </div>
`;

export class UserFeedbackBox {
    private static css = `
        .appreciationModalContainer > div.modal-body {
            padding: 16px 14px 14px 14px;
        }
        .appreciationModalContainer button.userfeedback {
            font-size: 14px;
            font-weight: normal;
            color: #105ce8;
            position: absolute;
            bottom: 14px;
            background-color: white;
        }
        .appreciationModalContainer {
            min-height: 150px !important;
            max-width: 375px !important;
            border-radius: 5px !important;
        }
        #userFeedbackToolModal {
            overflow: auto !important;
        }
        #userFeedbackToolModal .modal-close {
            display: none;
        }
        .userFeedbackContainer {
            width: 381px !important;
            border-radius: 5px !important;
        }
        #userFeedbackToolModal .modal-body {
            padding-left: 27px !important;
            padding-right: 27px !important;
            padding-top: 28px !important;
        }
        #userFeedbackToolModal .feedbackBox { margin-bottom: 30px}
        #userFeedbackToolModal label, #appreciationModal label {
            font-size: 15px;
            color: #404040;
        }
        #userFeedbackToolModal button.userfeedback {
            font-family: Helvetica;
            font-size: 14px;
            font-weight: normal;
            color: #105ce8;
            border: none;
            background-color: white;
        }
        #userFeedbackToolModal div.box ul {
            padding-bottom: 10px;
            list-style: none;
            margin: 0;
            padding: 0;
        }
        #userFeedbackToolModal ul.radiogroup li {
            display: inline-block;
        }
        #userFeedbackToolModal ul.radiogroup {
            padding: 0;
            margin-bottom: 24px;
        }
        #userFeedbackToolModal ul.radiogroup input[type=radio] {
            position: fixed;
            opacity: 0;
            height:35px;
            width: 140px;
        }
        #userFeedbackToolModal ul.radiogroup input[type=radio] ~ label {
            border: 1px solid #105ce8;
            border-radius: 100px;
            color: #105ce8;
            margin-top: 0px;
            min-width: 128px;
            text-align: center;
            font-size: 12px;
            padding: 8px 16px 8px 16px;
        }
        #userFeedbackToolModal ul.radiogroup input[type=radio]:checked ~ label{
            background-color: #105ce8;
            color: white;
        }
        #userFeedbackToolModal ul.checkbox li {
            display: inline-block;
            width: 49%;
            margin-top: 0 !important;
        }
        #userFeedbackToolModal ul.checkbox {
            padding: 0;
        }
        #userFeedbackToolModal ul.checkbox li label {
            display: inline;
            font-size: 13px;
            color: #404040;
        }
        #userFeedbackToolModal textarea.field {
            width: 381px;
            height: 36px;
            border: solid 1px #c7c7c7;
            resize: none;
            max-width: 100%;
            font-size: 12px;
            padding: 10px 5px 10px 5px;
        }
        #userFeedbackToolModal textarea.field.otherField {
            margin-top: -20px;
        }
        .modal-background {
            background: #000000 !important;
            opacity: 0.6 !important;
        }
        [dir=ltr] #userFeedbackToolModal .feedbackFooter { right: 24px; }
        [dir=rtl] #userFeedbackToolModal .feedbackFooter { left: 24px; }
        [dir=ltr] .appreciationModalContainer button.userfeedback { right: 14px; }
        [dir=rtl] .appreciationModalContainer button.userfeedback { left: 14px; }
    `;

    private static isStyleAdded: boolean;

    private static addCss(): void {
        if (!UserFeedbackBox.isStyleAdded) {
            const style = document.createElement("style");
            style.type = "text/css";
            style.innerHTML = UserFeedbackBox.css;
            document.head.appendChild(style);
            if (!TypeaheadUtils.isWithinMobileBreakpoint()) {
                $(".userFeedbackContainer").css("margin", 0);
                $(".appreciationModal").css("margin", 0);
            }
            UserFeedbackBox.isStyleAdded = true;
        }
    }

    private readonly $userFeedbackBox: JQuery;

    constructor() {
        this.$userFeedbackBox = $(feedbackHtml);
        UserFeedbackBox.addCss();
        this.setLocalizedText();
    }

    public getJQueryElement(): JQuery {
        return this.$userFeedbackBox;
    }

    private setLocalizedText(): void {
        this.$userFeedbackBox.find("label.explain-issue-message").html(loc.explainIssueMessage ||
            "If you have a moment, please let us know what issue you were experiencing:");
        this.$userFeedbackBox.find("label#missing-message").html(loc.missingInformationMessage ||
            "Missing Information");
        this.$userFeedbackBox.find("label#wrong-message").html(loc.wrongInformationMessage ||
            "Wrong Information");
        this.$userFeedbackBox.find("label#irrelevant-message").html(loc.irrelevantInformationMessage ||
            "Irrelevant Information");
        this.$userFeedbackBox.find("label#other-message").html(loc.otherMessage || "Other");
        $("textarea.otherField").attr("placeholder", loc.describeOtherIssueMessage);
        this.$userFeedbackBox.find("textarea.otherField").attr("placeholder",
            loc.describeOtherIssueMessage || "Please describe your issue");

        this.$userFeedbackBox.find("label.what-destination-type-message").html(loc.whatDestinationTypeMessage ||
            "What kind of destination were you looking for?");
        this.$userFeedbackBox.find("label#city").html(loc.city || "City");
        this.$userFeedbackBox.find("label#address").html(loc.addressMessage || "Address");
        this.$userFeedbackBox.find("label#landmark").html(loc.landmarkMessage || "Landmark");
        this.$userFeedbackBox.find("label#hotel").html(loc.hotelMessage || "Hotel");
        this.$userFeedbackBox.find("label#train_station").html(loc.trainStationMessage || "Train Station");
        this.$userFeedbackBox.find("label#airport").html(loc.airportMessage || "Airport");

        this.$userFeedbackBox.find(".add-comment").html(loc.commentMessage || "Add a comment (optional):");
    }

}
